import _defineProperty from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["status", "addRole"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { AlertProvider, AlertStylesProvider, getStatusColorScheme } from "./chunk-FZCW3KO4.mjs";

// src/alert.tsx
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { jsx } from "react/jsx-runtime";
var Alert = forwardRef(function Alert2(props, ref) {
  var _a;
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$sta = _omitThemingProps.status,
    status = _omitThemingProps$sta === void 0 ? "info" : _omitThemingProps$sta,
    _omitThemingProps$add = _omitThemingProps.addRole,
    addRole = _omitThemingProps$add === void 0 ? true : _omitThemingProps$add,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var colorScheme = (_a = props.colorScheme) != null ? _a : getStatusColorScheme(status);
  var styles = useMultiStyleConfig("Alert", _objectSpread(_objectSpread({}, props), {}, {
    colorScheme: colorScheme
  }));
  var alertStyles = _objectSpread({
    width: "100%",
    display: "flex",
    alignItems: "center",
    position: "relative",
    overflow: "hidden"
  }, styles.container);
  return /* @__PURE__ */jsx(AlertProvider, {
    value: {
      status: status
    },
    children: /* @__PURE__ */jsx(AlertStylesProvider, {
      value: styles,
      children: /* @__PURE__ */jsx(chakra.div, _objectSpread(_objectSpread({
        role: addRole ? "alert" : void 0,
        ref: ref
      }, rest), {}, {
        className: cx("chakra-alert", props.className),
        __css: alertStyles
      }))
    })
  });
});
Alert.displayName = "Alert";
export { Alert };